import React from 'react';
import {
  serviceProviderSelectListEmpty,
} from './functions';

type ServiceProviderSelectProps<T extends { slug: string }[]> = {
  serviceProviders: T;
  isLoading: boolean;
  renderItem: (sp: T[number]) => React.ReactNode;
  hideEmpty?: boolean;
};

const ServiceProviderSelect = function<T extends { slug: string }[]>({
  serviceProviders,
  isLoading,
  renderItem,
  hideEmpty = false,
}: ServiceProviderSelectProps<T>) {
  return (
    <div
      className="flex flex-col overflow-auto h-full"
    >
      <div
        className="flex flex-wrap gap-4"
      >
        {serviceProviders?.map((serviceProvider, i) => {
          return (
            <div
              key={i}
              className="flex w-full border-b w-full border-gray-200 border-solid"
            >
              {renderItem(serviceProvider)}
            </div>
          );
        })}
      </div>
      {isLoading ? (
        <div className="flex flex-col gap-2 justify-center">
          <div className="skeleton-lg" />
          <div className="skeleton-md" />
          <div className="skeleton-lg" />
          <div className="skeleton-md" />
        </div>
      ) : serviceProviders.length === 0 &&
      (hideEmpty || serviceProviderSelectListEmpty())}
    </div>
  );
};

export default ServiceProviderSelect;

